var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysiotherapy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 900",
    id: "physiotherapy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff3f7",
    d: "M335.06,720.68c-24.46-18.8-132.33-106.36-143.47-233.06C176,309.86,363.39,198.83,414.81,168.38,532.68,98.56,816-6.75,995.68,150.56c143.88,126,132.57,357.74,43.62,490.32C892.7,859.36,529.08,869.86,335.06,720.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 928.85,
    y: 377.57,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 928.85,
    y: 435.33,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 961.29,
    y: 406.5,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 896.4,
    y: 406.5,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 217.07,
    y: 520.57,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 249.51,
    y: 578.32,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 262.99,
    y: 549.5,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 198.11,
    y: 549.5,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 594.46,
    y: 135.13,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 616.38,
    y: 192.99,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 640.39,
    y: 164.06,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 575.5,
    y: 164.06,
    fill: "none",
    stroke: "#fc7e85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 251.07,
    height: 293.07,
    x: 227.59,
    y: 110.2,
    fill: "#87dbf6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.14,
    height: 255.84,
    x: 362.19,
    y: 127.39,
    fill: "#c9effb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.14,
    height: 255.84,
    x: 241.91,
    y: 127.39,
    fill: "#c9effb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8e5f9",
    d: "M263.93 127.39s-14.4 163.54 13 200.52 67.16 27.78 67.16 27.78v27.54H241.91V127.39zM384.22 127.39s-14.4 163.54 13 200.52 67.15 27.78 67.15 27.78v27.54H362.19V127.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 108.7,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 119.42,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 130.14,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 140.86,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 151.57,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 162.29,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 173.01,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 183.73,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 194.44,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 205.16,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 215.73,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 226.45,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 237.17,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 247.88,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 258.6,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 269.32,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 280.04,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 290.75,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 301.47,
    fill: "#ff0068"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.64,
    height: 3,
    x: 213.8,
    y: 312.19,
    fill: "#ff0068"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a04833",
    d: "M957.76,156.32H860.31a10.87,10.87,0,0,0-10.87,10.87v96.74a10.88,10.88,0,0,0,10.87,10.88h97.45a10.88,10.88,0,0,0,10.88-10.88V167.19A10.88,10.88,0,0,0,957.76,156.32ZM959,256.11a9.11,9.11,0,0,1-9.11,9.12h-81.7a9.12,9.12,0,0,1-9.12-9.12V175a9.11,9.11,0,0,1,9.12-9.11h81.7A9.11,9.11,0,0,1,959,175Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.93,
    height: 99.33,
    x: 859.07,
    y: 165.9,
    fill: "#454851",
    rx: 9.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M928.87,193s-8.4-13.34-40.65-27.14h-20a9.11,9.11,0,0,0-9.12,9.11v30.86l41.47,7.75s1.93,33.41,8.5,51.61h33.85L941.1,216S945.28,199.6,928.87,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M923,218.59c6.16-1.59,5.57-9.34,5.57-9.34,9.14-18.5-13.73-17.5-13.73-17.5L862,168.37a9.08,9.08,0,0,0-2.88,6.64v7.19c9.65,1.19,50,23.47,50,23.47C907.23,221.36,916.84,220.18,923,218.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M937.53,229.18c.5-12.43-6.46-13.62-6.46-13.62-4.87,12.13-17.8,6.65-17.8,6.65.7,4.35,2,4.49,2,4.49,5.71.58,10.5,29.54,11.85,38.53h12.95C936.42,251.75,937.06,240.86,937.53,229.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M920 246.47c-.21-2-2.57-16.09-8.48-16.66l-.49 0 .4 7.45s-2.66 2.33-.72 6.81c1.36 3.15 4.65 14.61 6.48 21.14h5.62L918.94 249A2.35 2.35 0 00920 246.47zM938 216.53c.23-.1.41-.36.6-2.09a20.42 20.42 0 000-6.34c-.56-3.49-1.06-6.68-2.76-7.08-1.13-.27-2.28.81-2.69 1.19a5.74 5.74 0 00-1.56 4.4 8.6 8.6 0 001.12 3.73C934.1 213.24 936.81 217 938 216.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M172.92,767.81l-1-.79c1-7.41,4.15-30,8.19-58.32,9.85-69.07,25.11-171.86,28.23-168.86,4.27,4.1,4.36,56.08-.55,117.1-.48,5.95-1,12-1.58,18.07q-.9,9.54-1.67,18.22c-2.26,5.49-4.67,11.11-7.2,16.78C180.52,747.74,172.92,767.81,172.92,767.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M179.11,757.87s4.34-21,15-60.91,16.38-77.08,13.36-80.6c-1.42-1.65-11.81,27.08-22.45,58.07-4.76,32.63-9,63.06-11.44,80.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M180.86,815.42l1.23-.34c1.91-7.23,7.73-29.32,14.89-57,17.48-67.56,43-168.3,38.92-166.73-5.52,2.15-25.6,50.08-44.55,108.29q-2.78,8.52-5.5,17.29-2.83,9.15-5.47,17.47c0,5.93,0,12.05.19,18.25C181.58,794,180.86,815.42,180.86,815.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M75.18,649.63a44.77,44.77,0,0,1,5.14-2.46c1.75-.74,3.53-1.37,5.34-1.95a73.25,73.25,0,0,1,11.16-2.59,70.84,70.84,0,0,1,23.5.23,59,59,0,0,1,11.74,3.4,55.44,55.44,0,0,1,5.6,2.71l1.36.76c.45.26.88.55,1.33.83.87.58,1.77,1.11,2.61,1.73a63.25,63.25,0,0,1,9.38,8.29l2.07,2.33c.17.2.35.4.5.59l.45.57.89,1.13,3.59,4.55c2.19,3.16,4.52,6.25,6.43,9.58l1.48,2.48c.25.41.5.82.73,1.24l.68,1.27,2.68,5.09c1.64,3.46,3.3,6.9,4.7,10.45l1.12,2.64,1,2.67,1,2.68.5,1.33.46,1.36c.6,1.8,1.3,3.57,1.95,5.37s1.32,3.58,2,5.37,1.21,3.64,1.73,5.48.88,3.72,1.22,5.6c.14.95.26,1.9.37,2.85s.21,1.91.29,2.86c.11,1.92.22,3.84.18,5.77a53.7,53.7,0,0,1-.35,5.79,39.41,39.41,0,0,1-1.05,5.81l-11.87.42c-1.3-3.36-2.26-6.68-3.19-10l-.69-2.48c-.2-.83-.44-1.66-.63-2.49q-.67-2.48-1.23-5c-.42-1.66-.76-3.32-1.05-5s-.61-3.35-.89-5-.65-3.36-1-5-.89-3.3-1.4-4.93l-.4-1.22-.44-1.2-.9-2.41c-.3-.8-.6-1.6-.92-2.39l-1-2.34c-1.32-3.15-2.93-6.15-4.46-9.19l-2.53-4.42-.63-1.1c-.22-.36-.45-.71-.68-1.07l-1.37-2.14-1.35-2.14c-.43-.73-1-1.39-1.44-2.09L146,680l-3.13-4-.78-1-.4-.49c-.13-.16-.26-.29-.39-.44l-1.55-1.7c-.51-.57-1.09-1.06-1.63-1.6l-.83-.79c-.28-.26-.58-.49-.87-.74-.59-.48-1.15-1-1.75-1.46l-1.83-1.37c-.6-.47-1.26-.86-1.89-1.3-.31-.21-.62-.43-1-.63l-1-.59c-1.28-.83-2.65-1.54-4-2.3a78.88,78.88,0,0,0-8.65-3.88,93.9,93.9,0,0,0-19.43-4.94c-3.42-.53-6.91-.91-10.46-1.19s-7.18-.46-10.84-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M174.78 755l0-1.35c0-.85-.07-1.71-.12-2.56l-.23-2.55c-.26-3.4-.83-6.76-1.32-10.12l-1-5-.25-1.25c-.09-.41-.21-.82-.31-1.23l-.62-2.46-.6-2.47c-.18-.83-.48-1.62-.7-2.43l-1.43-4.86-1.71-4.76-.43-1.19-.22-.59c-.07-.19-.15-.35-.23-.53l-.93-2.11c-.3-.7-.7-1.35-1-2l-.53-1c-.18-.33-.39-.65-.59-1-.41-.64-.77-1.31-1.2-1.94l-1.3-1.87c-.42-.64-.92-1.22-1.38-1.83-.23-.3-.45-.61-.7-.91l-.27-.31c1.3 2.54 2.61 5.07 3.71 7.71l1 2.34c.32.79.62 1.59.92 2.39l.9 2.41.44 1.2.4 1.22c.51 1.63 1 3.26 1.4 4.93s.69 3.36 1 5 .54 3.38.89 5 .63 3.34 1.05 5 .78 3.31 1.23 5c.19.83.43 1.66.63 2.49l.69 2.48C172.77 748.88 173.65 751.91 174.78 755zM125 661.66c1.36.76 2.73 1.47 4 2.3l1 .59c.33.2.64.42 1 .63.63.44 1.29.83 1.89 1.3l1.83 1.37.06 0a70.49 70.49 0 0120.89 7.41 59.57 59.57 0 0110.06 7 56.88 56.88 0 014.45 4.34l.59.65-1.54-2.93-.68-1.27c-.23-.42-.48-.83-.73-1.25l-1.48-2.47c-1.91-3.33-4.24-6.42-6.43-9.58l-3.59-4.55-.89-1.13-.45-.57c-.15-.19-.33-.39-.5-.59l-2.07-2.33a63.25 63.25 0 00-9.38-8.29c-.84-.62-1.74-1.15-2.61-1.73-.45-.28-.88-.57-1.33-.83l-1.36-.76a55.44 55.44 0 00-5.6-2.71 59 59 0 00-11.74-3.4 70.84 70.84 0 00-23.5-.23 73.25 73.25 0 00-11.16 2.59c-1.81.58-3.59 1.21-5.34 1.95a44.77 44.77 0 00-5.14 2.46l.42 1.49c3.66.07 7.28.24 10.84.53s7 .66 10.46 1.19a93.9 93.9 0 0119.43 4.94A78.88 78.88 0 01125 661.66zM290.92 636.69a45 45 0 00-5.44-1.7c-1.84-.47-3.69-.84-5.57-1.15a74.64 74.64 0 00-11.41-1 70.82 70.82 0 00-23.22 3.63 59.12 59.12 0 00-11.13 5.06 56.81 56.81 0 00-5.15 3.49l-1.24.95c-.4.33-.79.68-1.19 1-.77.69-1.59 1.35-2.33 2.08a62.92 62.92 0 00-8.08 9.56l-1.71 2.61c-.14.22-.3.44-.42.65l-.36.63-.72 1.25-2.89 5c-1.71 3.44-3.56 6.84-5 10.41L204 681.92c-.19.44-.38.88-.55 1.33l-.48 1.36L201 690c-1.12 3.66-2.27 7.31-3.14 11l-.72 2.77-.61 2.79-.63 2.79-.3 1.39-.26 1.41c-.33 1.87-.77 3.73-1.16 5.6s-.78 3.73-1.18 5.61-.67 3.76-.93 5.66-.32 3.81-.39 5.73c0 1 0 1.91 0 2.87s.07 1.91.12 2.87c.17 1.92.34 3.82.66 5.73a53 53 0 001.18 5.68 39.92 39.92 0 001.88 5.59l11.81-1.3c.8-3.51 1.26-6.93 1.7-10.36l.33-2.55c.08-.86.2-1.71.26-2.56.21-1.7.37-3.39.5-5.09s.27-3.39.32-5.09.12-3.41.15-5.13.16-3.42.27-5.13.4-3.4.67-5.09l.22-1.26.26-1.25.54-2.51c.18-.84.37-1.67.57-2.5l.68-2.47c.85-3.3 2-6.51 3.08-9.73l1.87-4.74.46-1.18c.16-.39.35-.78.52-1.16l1.05-2.31 1-2.32c.32-.79.76-1.51 1.12-2.28l2.26-4.53 2.53-4.38.63-1.09.32-.55a5.72 5.72 0 01.32-.48l1.29-1.91c.42-.64.93-1.21 1.38-1.82l.71-.91c.24-.29.5-.57.75-.85.52-.56 1-1.16 1.52-1.71l1.62-1.61c.52-.55 1.12-1 1.67-1.56.29-.25.56-.52.85-.77s.6-.47.89-.72c1.16-1 2.41-1.91 3.64-2.86a80.63 80.63 0 018-5.09A94.32 94.32 0 01269.89 643c3.31-1 6.71-1.91 10.19-2.7s7-1.49 10.64-2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M238,660.14a.69.69,0,0,0,.13-.11,68.09,68.09,0,0,0-9.77,3.77,59.51,59.51,0,0,0-10.43,6.38,56.6,56.6,0,0,0-4.68,4.09l-1.12,1.09c-.36.38-.7.77-1,1.16-.69.78-1.42,1.53-2.07,2.35a64.06,64.06,0,0,0-6.86,10.48l-1.38,2.79-.33.7-.28.67-.56,1.33-.1.25c-.59,2-1.14,4-1.61,6l-.72,2.77-.61,2.79-.63,2.79-.3,1.39-.26,1.41c-.33,1.87-.77,3.73-1.16,5.6s-.78,3.73-1.18,5.61-.67,3.76-.93,5.66-.32,3.81-.39,5.73c0,1,0,1.91,0,2.87s.07,1.91.12,2.87c.17,1.92.34,3.82.66,5.73a53,53,0,0,0,1.18,5.68,39.92,39.92,0,0,0,1.88,5.59l9.26-1a1.64,1.64,0,0,1,0-.22q-.21-2.55-.36-5.13c-.07-1.71,0-3.42.05-5.13l.06-1.28.11-1.28.23-2.55c.08-.85.16-1.7.26-2.55l.37-2.53c.44-3.39,1.2-6.71,1.88-10l1.27-4.93.32-1.23c.11-.41.25-.81.38-1.21l.75-2.43.74-2.42c.22-.82.57-1.59.83-2.4l1.7-4.77.36-.86.09-.31c.85-3.3,2-6.51,3.08-9.73l1.87-4.74.46-1.18c.16-.39.35-.78.52-1.16l1.05-2.31,1-2.32c.32-.79.76-1.51,1.12-2.28l2.26-4.53,2.53-4.38.63-1.09.32-.55a5.72,5.72,0,0,1,.32-.48l1.29-1.91c.42-.64.93-1.21,1.38-1.82l.71-.91c.24-.29.5-.57.75-.85.52-.56,1-1.16,1.52-1.71l1.62-1.61C236.85,661.15,237.45,660.67,238,660.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M205.88,759.94l-1.27-.14c-3.05-6.84-12.34-27.7-23.84-53.85-28.11-63.86-69.42-159.21-65.19-158.31,5.79,1.23,33.31,45.32,61.36,99.73,2.73,5.31,5.48,10.71,8.2,16.19q4.28,8.57,8.21,16.36c1,5.85,1.9,11.89,2.74,18.05C201.73,738.88,205.88,759.94,205.88,759.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M205.88,748.23s-7.4-20.13-19.39-59.66-26.8-74.1-31.22-75.5c-2.08-.66,4.27,29.23,11.6,61.17,13.18,30.22,25.63,58.32,32.72,74.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M205.88,759.94l-1.27-.14-19.78-2.23s-2-23.74-4.06-51.62c-1.47-19.78-3-41.66-3.83-58.58-.87-17.34-1.06-29.49.18-28.87,3.52,1.76,10.69,28.36,16.23,61.42,1,5.85,1.9,11.89,2.74,18.05C201.73,738.88,205.88,759.94,205.88,759.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M320.7,739.78c-5.92-4.91-11.73-9.4-17.08-14-2.66-2.31-5.23-4.6-7.55-7a57.84,57.84,0,0,1-6.15-7.12,38.91,38.91,0,0,1-2.28-3.48q-.22-.44-.48-.84c-.16-.28-.27-.56-.42-.83l-1.3-2.55a44.39,44.39,0,0,0-3.57-5.55,48.07,48.07,0,0,0-4.37-5,51.94,51.94,0,0,0-10.56-8,49.73,49.73,0,0,0-12.35-5.15,37.43,37.43,0,0,0-6.84-1.14,31,31,0,0,0-7.24.27,27.07,27.07,0,0,0-7.28,2.18A32.7,32.7,0,0,0,227,685.4a40.19,40.19,0,0,0-5.09,4.58A49.29,49.29,0,0,0,217.7,695,64.8,64.8,0,0,0,211.42,706,90.58,90.58,0,0,0,205,729.12c-.3,2-.6,3.88-.86,5.82l-.38,2.91c-.12,1-.21,1.93-.34,2.9-.47,3.86-.91,7.71-1.66,11.57l18.52.63a49.19,49.19,0,0,1-.17-10.5,83.33,83.33,0,0,1,1.52-10.27c.72-3.36,1.6-6.66,2.62-9.87s2.1-6.35,3.36-9.35c.61-1.5,1.25-3,2-4.4s1.42-2.82,2.21-4.14a40.82,40.82,0,0,1,2.49-3.76,24.83,24.83,0,0,1,2.76-3.19,17,17,0,0,1,3-2.33,11,11,0,0,1,3.18-1.3,14.9,14.9,0,0,1,3.78-.35,18.65,18.65,0,0,1,4.05.61,21.5,21.5,0,0,1,7.72,4,30.54,30.54,0,0,1,6,6.55c.85,1.23,1.63,2.51,2.37,3.79s1.39,2.63,2.06,4l.47,1,.12.25a2.63,2.63,0,0,0,.15.31l.41.82c.29.54.56,1.1.87,1.62s.62,1,.94,1.53a36.21,36.21,0,0,0,4.32,5.38,51.19,51.19,0,0,0,10,7.94c1.76,1.08,3.52,2.07,5.33,3s3.63,1.69,5.47,2.41A74.16,74.16,0,0,0,308.48,740c1.9.41,3.82.77,5.76,1a45.58,45.58,0,0,0,5.88.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M203.74,737.85l.38-2.91c.26-1.94.56-3.87.86-5.82A90.58,90.58,0,0,1,211.42,706,64.8,64.8,0,0,1,217.7,695a49.29,49.29,0,0,1,4.19-5.06A40.19,40.19,0,0,1,227,685.4a36.66,36.66,0,0,1,3.34-2.24c22.6,1.27,30.07,12.16,32.54,19a28.85,28.85,0,0,0-4.17-4.1,21.5,21.5,0,0,0-7.72-4,18.65,18.65,0,0,0-4.05-.61,14.9,14.9,0,0,0-3.78.35,11,11,0,0,0-3.18,1.3,17,17,0,0,0-3,2.33,24.83,24.83,0,0,0-2.76,3.19,40.82,40.82,0,0,0-2.49,3.76c-.79,1.32-1.51,2.71-2.21,4.14s-1.35,2.9-2,4.4c-1.26,3-2.34,6.15-3.36,9.35s-1.9,6.51-2.62,9.87a83.33,83.33,0,0,0-1.52,10.27,49.19,49.19,0,0,0,.17,10.5l-18.52-.63c.75-3.86,1.19-7.71,1.66-11.57C203.53,739.78,203.62,738.81,203.74,737.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7bce34",
    d: "M58.32,739.78c5.92-4.91,11.73-9.4,17.08-14,2.66-2.31,5.23-4.6,7.55-7a57.84,57.84,0,0,0,6.15-7.12,41.24,41.24,0,0,0,2.28-3.48q.23-.44.48-.84c.16-.28.27-.56.42-.83l1.3-2.55a44.39,44.39,0,0,1,3.57-5.55,48.07,48.07,0,0,1,4.37-5,51.87,51.87,0,0,1,10.55-8,50.05,50.05,0,0,1,12.35-5.15,37.54,37.54,0,0,1,6.85-1.14,31,31,0,0,1,7.24.27,27.18,27.18,0,0,1,7.28,2.18A32.7,32.7,0,0,1,152,685.4a40.89,40.89,0,0,1,5.09,4.58,52,52,0,0,1,4.19,5.06A64.06,64.06,0,0,1,167.59,706,90.61,90.61,0,0,1,174,729.12c.3,2,.6,3.88.86,5.82l.38,2.91c.12,1,.21,1.93.34,2.9.47,3.86.91,7.71,1.66,11.57l-18.52.63a49.19,49.19,0,0,0,.17-10.5,81.48,81.48,0,0,0-1.53-10.27c-.71-3.36-1.59-6.66-2.61-9.87s-2.1-6.35-3.36-9.35c-.62-1.5-1.25-3-2-4.4s-1.41-2.82-2.21-4.14a38.8,38.8,0,0,0-2.48-3.76,25.64,25.64,0,0,0-2.76-3.19,17.38,17.38,0,0,0-2.95-2.33,11,11,0,0,0-3.18-1.3,15,15,0,0,0-3.78-.35,18.74,18.74,0,0,0-4.06.61,21.54,21.54,0,0,0-7.71,4,30.58,30.58,0,0,0-6,6.55c-.84,1.23-1.62,2.51-2.36,3.79s-1.4,2.63-2.06,4l-.47,1-.12.25-.15.31-.42.82c-.28.54-.55,1.1-.86,1.62s-.62,1-.94,1.53a35.64,35.64,0,0,1-4.33,5.38,50.85,50.85,0,0,1-10,7.94c-1.76,1.08-3.52,2.07-5.33,3s-3.63,1.69-5.47,2.41A74.16,74.16,0,0,1,70.54,740c-1.91.41-3.82.77-5.76,1a45.71,45.71,0,0,1-5.88.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c8f2d",
    d: "M175.28,737.85l-.38-2.91c-.26-1.94-.56-3.87-.86-5.82A90.61,90.61,0,0,0,167.59,706,64.06,64.06,0,0,0,161.32,695a52,52,0,0,0-4.19-5.06A40.89,40.89,0,0,0,152,685.4a36.66,36.66,0,0,0-3.34-2.24c-22.6,1.27-30.07,12.16-32.54,19a28.85,28.85,0,0,1,4.17-4.1,21.54,21.54,0,0,1,7.71-4,18.74,18.74,0,0,1,4.06-.61,15,15,0,0,1,3.78.35,11,11,0,0,1,3.18,1.3,17.38,17.38,0,0,1,2.95,2.33,25.64,25.64,0,0,1,2.76,3.19,38.8,38.8,0,0,1,2.48,3.76c.8,1.32,1.52,2.71,2.21,4.14s1.35,2.9,2,4.4c1.26,3,2.34,6.15,3.36,9.35s1.9,6.51,2.61,9.87a81.48,81.48,0,0,1,1.53,10.27,49.19,49.19,0,0,1-.17,10.5l18.52-.63c-.75-3.86-1.19-7.71-1.66-11.57C175.49,739.78,175.4,738.81,175.28,737.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M221.88,831.1h-56a14.6,14.6,0,0,1-14.43-12.43l-9.87-65.75c-.68-4.56,32.83-.95,53.35-1.15,19.34-.2,50.94-2,50.59.28l-9.19,66.62A14.59,14.59,0,0,1,221.88,831.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91a6b5",
    d: "M193.53,751.78c-20.52.21-52.65-3.42-52,1.14l9.87,65.75a14.6,14.6,0,0,0,14.43,12.43H188a35.33,35.33,0,0,1-9.12-23.43c0-1.79.22-13.32,8.6-22.53,5-5.5,13.12-8.31,29.35-13.94,7.8-2.7,14-4.06,20.76-9.78a47.9,47.9,0,0,0,7.67-7.73l.22-1.64C245.85,749.77,212.86,751.59,193.53,751.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9d9f9f",
    d: "M976.77,552.31a4.2,4.2,0,0,1,4.2-4.2h125.16V831.37H981a4.21,4.21,0,0,1-4.2-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454851",
    d: "M1106.13,548.1V831.37h31.35a4.21,4.21,0,0,0,4.2-4.21V552.31a4.21,4.21,0,0,0-4.2-4.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.18,
    height: 39.34,
    x: 987.69,
    y: 563.51,
    fill: "#e3eaf3",
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M1091.38,563.51h-10.33a4,4,0,0,1,3.82,4.2v30.94a4,4,0,0,1-3.82,4.2h10.33a4,4,0,0,0,3.83-4.2V567.71A4,4,0,0,0,1091.38,563.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.28,
    cy: 583.18,
    fill: "#9d9f9f",
    rx: 6.13,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.18,
    height: 39.34,
    x: 987.69,
    y: 616.79,
    fill: "#e3eaf3",
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M1091.38,616.79h-10.33a4,4,0,0,1,3.82,4.2v30.94a4,4,0,0,1-3.82,4.2h10.33a4,4,0,0,0,3.83-4.2V621A4,4,0,0,0,1091.38,616.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.28,
    cy: 636.46,
    fill: "#9d9f9f",
    rx: 6.13,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.18,
    height: 39.34,
    x: 987.69,
    y: 670.07,
    fill: "#e3eaf3",
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M1091.38,670.07h-10.33a4,4,0,0,1,3.82,4.2v30.94a4,4,0,0,1-3.82,4.2h10.33a4,4,0,0,0,3.83-4.2V674.27A4,4,0,0,0,1091.38,670.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.28,
    cy: 689.74,
    fill: "#9d9f9f",
    rx: 6.13,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.18,
    height: 39.34,
    x: 987.69,
    y: 723.35,
    fill: "#e3eaf3",
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M1091.38,723.35h-10.33a4,4,0,0,1,3.82,4.2v30.94a4,4,0,0,1-3.82,4.2h10.33a4,4,0,0,0,3.83-4.2V727.55A4,4,0,0,0,1091.38,723.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.28,
    cy: 743.02,
    fill: "#9d9f9f",
    rx: 6.13,
    ry: 6.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.18,
    height: 39.34,
    x: 987.69,
    y: 776.63,
    fill: "#e3eaf3",
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M1091.38,776.63h-10.33a4,4,0,0,1,3.82,4.2v30.94a4,4,0,0,1-3.82,4.2h10.33a4,4,0,0,0,3.83-4.2V780.83A4,4,0,0,0,1091.38,776.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.28,
    cy: 796.3,
    fill: "#9d9f9f",
    rx: 6.13,
    ry: 6.73
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Head/Female"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.71,289s-22-9.56-30.49,9.35S516.7,378,494.5,381.35c0,0,12.24,7.55,24.37-7.29s20.21-28.62,22.47-35.44a69.46,69.46,0,0,1-13.62,34.73c-12.76,17-31.15,48.82-7.61,54.38,0,0-12.23-5.28-.06-20.43s72.65-66.44,48.12-105.68C563.37,293.94,568.71,289,568.71,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M585.42,286.08c-12.4,2.42-20,18.21-18.25,36.53l-.1,0c-3.39.66-5.39,5-4.46,9.76s4.41,8,7.8,7.38a4.6,4.6,0,0,0,1.3-.47c6.88,13.88,20.25,21.6,31.25,19.46,13.66-2.67,18.49-19.52,14.47-40.15S599.07,283.42,585.42,286.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M598.61,369.58c-.62-2.21,2-7.61,3.6-10.72-10.85,1.67-23.77-6-30.5-19.56a4.6,4.6,0,0,1-1.3.47s-1,28.21-7.17,28.56c-7.14,6.13-30.5,26.9-25.75,36.53,4,8.08,25.56,3.91,57.72-2.3a16.21,16.21,0,0,0,8.39-4c6.74-6.43,4.9-18,3.95-20.61C606.32,374.54,599.52,372.78,598.61,369.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M569.5 351c.72-6 .91-11.24.91-11.24a4.6 4.6 0 001.3-.47c6.73 13.56 19.65 21.23 30.5 19.56a47.94 47.94 0 00-3.13 7.06c-.27.07-.54.14-.82.19C588.46 368 576.8 362.11 569.5 351zM567 326.83a13.74 13.74 0 00-.07 5 10.28 10.28 0 00.75 2.23c.15.4.39.76.57 1.17s.45.79.64 1.27a6.74 6.74 0 01-1.35-.59 5.87 5.87 0 01-1.15-1 5.54 5.54 0 01-1.42-2.72 5.47 5.47 0 01.23-3.08A4.77 4.77 0 01567 326.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M563.24,368.33c3.73-.21,5.58-10.78,6.45-19l5.47,2.46,4.69,9.8s-9,2-4.69,11.2c3.83,8.29,14,27.11,28.7,25.5-2.13,1.18-5.06,2.71-8.65,4.27-23.55,10.24-55.68,13.48-60.36,4.22S553.55,376.56,563.24,368.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.6,304.35s-6.27-9.75-8.09-7.57-5.32,8.06-17.24,7.44c0,0-7.95,10.4-9.64,22.6s-10.56-4.19-10.56-4.19-11.39-28.41.92-35.17,24.64-6.91,36.94,0S612.6,304.35,612.6,304.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be3e5f",
    d: "M611.3,345.24c-9.95.46-11.12-7.22-11.12-7.22a26.51,26.51,0,0,0,12.42.86S609.65,342.21,611.3,345.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M608.5,317.2c.45,2,.85,4,1.4,5.93a11.77,11.77,0,0,0,1.05,2.6c.2.34.54.8.82,1.23s.57.89.83,1.37a6.41,6.41,0,0,1,.93,3.44,3,3,0,0,1-.94,1.92,3.8,3.8,0,0,1-1.68.88,12.37,12.37,0,0,1-6.34-.45,23.62,23.62,0,0,0,5.84-1,2.77,2.77,0,0,0,.94-.64,1.08,1.08,0,0,0,.29-.81,5.42,5.42,0,0,0-.8-2.36c-.22-.42-.47-.84-.73-1.26s-.53-.81-.81-1.38a10.42,10.42,0,0,1-.92-3.18A19.6,19.6,0,0,1,608.5,317.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.25 313.1a42.34 42.34 0 00-5.89 1.37 17.94 17.94 0 00-2.7 1.09c-.91.42-1.72 1-2.67 1.52a7 7 0 012-2.52 9 9 0 012.88-1.55 10.6 10.6 0 013.21-.5A7.91 7.91 0 01602.25 313.1zM612.48 311.16a8.82 8.82 0 012.76-.65q.27.74.51 1.5h0a17.81 17.81 0 00-2.9.29c-1 .14-1.93.46-3 .71A6.92 6.92 0 01612.48 311.16zM614.83 324.76a1.53 1.53 0 01-1.8-1.21l-.86-4.4a1.53 1.53 0 013-.58L616 323A1.53 1.53 0 01614.83 324.76zM599.41 325.7a1.53 1.53 0 01-1.8-1.21l-.85-4.39a1.53 1.53 0 113-.59l.86 4.4A1.53 1.53 0 01599.41 325.7zM589.31 301.73a58.9 58.9 0 00-4.5 7 73.24 73.24 0 00-3.66 7.57 62 62 0 00-4.36 16.24 49.57 49.57 0 00.75 16.82A50.25 50.25 0 00584 365a49.61 49.61 0 01-8.72-32.65 63.81 63.81 0 013.75-16.9 78.08 78.08 0 013.43-8 63.46 63.46 0 014.44-7.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M545.06,305.88l17.1,6.63S572.9,283.38,599.94,285c0,0-12.78-20.89-23.55-19.43S546.39,285.78,545.06,305.88Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.84,
    x2: 583.12,
    y1: 275.5,
    y2: 284.36,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 584.41,
    x2: 575.55,
    y1: 276.79,
    y2: 283.07,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M559.05,299.65c-7.91,2.63-12.17-2.93-12.18-2.94a37.93,37.93,0,0,0-1.81,9.17l17.1,6.63S572.9,283.38,599.94,285C579,281.67,567,297,559.05,299.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M547.53,306.83a79,79,0,0,1,12.89-25.2,59.06,59.06,0,0,1,4.8-5.33,38.12,38.12,0,0,1,5.63-4.49,22.47,22.47,0,0,1,13.56-4,26.24,26.24,0,0,0-12.68,5.26,52.45,52.45,0,0,0-9.74,9.78,104.89,104.89,0,0,0-7.8,11.56Q550.64,300.47,547.53,306.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Torso"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M705.88,478.65l10.33.41s2.24-1.78,5.29-4.1c5.75-4.4,14.37-10.72,16.14-10.62,2.71.17,7.43,2.14-4.3,11.16l.09.08c.4.3,2.2,1.49,6.84,1.77,5.33.32,23.28,1.55,26.19,2.64,1.59.6,5.13,5.35-21.48,4.42a1.43,1.43,0,0,0-1.5,1.6c.08.5.44.93,1.41,1,2.41.14,23.21.5,22.86,4.25-.27,2.74-5.71,2.07-24,1.27,0,0-2.89.74-.58,2.23.8.52,21.41,2.44,22.42,4.08s3.67,4.3-27.26.92c0,0-.55.31,2.14,1.89,2.86,1.67,11.33,3.91,13.49,7.06s-4.12.66-20-4.68l-22.29-2.83c-14.72,2.07-69.84,6.78-83.54-7.44-12.82-13.32-19.73-60.95-19.73-60.95l31.38-1.06L653,467.29a6.88,6.88,0,0,0,5.48,4.43l49.32,7.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M620.3,432.4,631.48,434s-2.92,38.29,7.4,46,24.72,14.64,86.4,14.88c19.94.08,32.63,2,40.67,4.48.83,1.54.08,3.43-27.58.4,0,0-.55.31,2.14,1.89,2.86,1.67,11.33,3.91,13.49,7.06s-4.12.66-20-4.68l-22.29-2.83c-14.72,2.07-69.84,6.78-83.54-7.44-12.82-13.32-19.73-60.95-19.73-60.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2f170b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M733.66,475.56s-4.32,16.17-19.08,11.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5061",
    d: "M446.83,584.31H533a7.33,7.33,0,0,1,7.33,7.33v46.51a0,0,0,0,1,0,0H439.5a0,0,0,0,1,0,0V591.64A7.33,7.33,0,0,1,446.83,584.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fc7e85",
    points: "439.5 638.15 439.5 627.53 450.47 638.15 439.5 638.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fc7e85",
    points: "540.38 638.15 540.38 627.53 529.41 638.15 540.38 638.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7e85",
    d: "M439.5,591.64v2.67H540.38v-2.67a7.33,7.33,0,0,0-7.33-7.33H446.83A7.33,7.33,0,0,0,439.5,591.64Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 706.43,
    x2: 706.43,
    y1: 478.65,
    y2: 500.83,
    fill: "none",
    stroke: "#2f170b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M643.57,428.8l-10.31-32.33a38.94,38.94,0,0,0-13-19,28.12,28.12,0,0,0-5.07-3.22,1,1,0,0,0-1.43.94l1.9,58.8h24A4,4,0,0,0,643.57,428.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M614.21,387.68l1.5,46.34h15.77c.37-11.25-.47-23.69-7.05-37.51-4.48-9.42-7.07-9.9-8.16-9.84A3.27,3.27,0,0,0,614.21,387.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M469.75,568.35a24.35,24.35,0,0,0,.73-5.51c.23-15.57,1.71-75,10.67-102,2.86-8.63,29.07-52.54,29.07-52.54l37.44,7.92-33,54.78a27.44,27.44,0,0,0-3.18,7.84l-20.11,85.64a8.07,8.07,0,0,0,1.49,6.82c4.23,5.43,12.61,16.46,12.47,18.49-.18,2.71-2.18,7.41-11.13-4.37,0,0-1.53,1.58-1.89,6.91s-1.12,25.84-2.81,26.18-5.49,5.23-4.23-22.66c0,0-2.48-1.37-2.64,1s-1.54,25.29-4.4,22.83-2-5.73-1.12-24c0,0-1.86-1.48-2.22-.6s-2.42,22.51-4.22,22.39-4.33,3.64-.75-27.26c0,0-1-.52-2.14,2.58s-5.5,16.71-6.91,13-.63-4.12,4.81-19.93l4.05-17.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M547.66,416.21l-8.84-1.87c-6.59,8.37-14.8,14.46-25.48,30.1C505,456.62,499.63,469,497.23,474.27c-6.56,14.36-5.22,21.68-9.6,57.12-2.62,21.27-3.94,31.91-5.32,37.48,0,0-9.88,39.85-5.05,49.72a2.72,2.72,0,0,0,1,1.12c2.86,2.46,4.24-20.43,4.4-22.83s2.64-1,2.64-1c-1.26,27.89,2.54,23,4.23,22.66s2.45-20.76,2.81-26.15h0v0c.36-5.33,1.89-6.91,1.89-6.91,8.95,11.78,10.95,7.08,11.13,4.37.14-2-8.24-13.06-12.47-18.49a8.07,8.07,0,0,1-1.49-6.82l20.11-85.64a27.44,27.44,0,0,1,3.18-7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M614.08,502.17H536.57a8.42,8.42,0,0,1-8.33-9.69l18.29-120.71,16.68-6.32c6.73,14.27,29.62,17.07,36.24,2.74l14.3,5.44a10.91,10.91,0,0,1,8.31,11.16l-.15,4.5-3.57,108.76C618.33,498.34,618.25,499.8,614.08,502.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M495.94,432.22a4,4,0,0,1-1-5.67l28.21-39.16s10-12.88,23.34-15.62l7.62,39.74-26.95,41a1.36,1.36,0,0,1-1.91.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M527.2,452.47,554,411.79l-.06-.39a4.34,4.34,0,0,0-6.9-2.8c-5.11,3.88-11.64,10.57-17.62,16.71-6.24,6.4-12.94,13.27-16,19.13l11.95,8.39A1.36,1.36,0,0,0,527.2,452.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M618.34,498.05c-5.87-2.08-21.16-2.15-44.31-9.44-21.72-6.85-26.1-12.41-28.08-16.38-4.65-9.36-1.61-21.22-.36-26.1,2.25-8.77,2.88-12.11,7.38-23.22,1.51-3.73,2-12.76,0-13.5-2.33-.86-8.92,9.19-15.65,23.16l-9.08,59.91a8.42,8.42,0,0,0,8.33,9.69h77.51a4.26,4.26,0,0,0,4.26-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7e85",
    d: "M506.94,584.31H494.88a7.78,7.78,0,0,0-.81,3.77c0,2.43,3.24,4.86,3.24,4.86s6.57,1.26,8.1.54S506.94,584.31,506.94,584.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.8,
    height: 9.08,
    x: 553.97,
    y: 399.56,
    fill: "#e3eaf3",
    rx: 2,
    transform: "rotate(-180 565.87 404.1)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc7829",
    d: "M668.11,819c-10.81-7.9-35.5-16.73-42.4-31.5-3.72,4.54-24.08,3.34-32,3.07h0s-5.88,13.23-5.22,21.93,1.38,18.38,1.38,18.38l14.66.42-.24-9.74s8.12-1.62,13.13,2.48,18.62,8.8,32.63,6.78S678.92,826.92,668.11,819Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c2f13",
    d: "M588.47,810.39c0-.65.07-1.31.14-2,0,0,0-.08,0-.11.08-.7.18-1.41.3-2.12a.5.5,0,0,1,0-.12c.11-.69.25-1.38.4-2.06l0-.16c.32-1.43.69-2.85,1.09-4.19l0-.1c.4-1.36.82-2.64,1.23-3.78h0c1.08-3.08,2-5.19,2-5.19h0c1.91.06,4.54.18,7.49.26a15.54,15.54,0,0,1,1.45,1.78c5.15,8.64,13.25,19,25.93,26.07,13.79,7.65,28.67,9,35.68,9.72-4,1-9.17,1.69-14.21,2.42-.9.13-1.79.23-2.68.31h-.21c-.75.06-1.5.11-2.25.13-.4,0-.79,0-1.19,0h-1.29c-.41,0-.82,0-1.22,0l-1.23,0-1.2-.1-1.19-.1-1.18-.15-1.15-.16c-.38-.05-.76-.12-1.13-.18l-1.13-.21-1.08-.22-1.09-.25-1-.26-1.05-.28-1-.28-1-.32-.9-.3-1-.36-.82-.31-.91-.38-.73-.32-.87-.42-.64-.31-.82-.45-.53-.3-.8-.51-.38-.24c-.36-.25-.7-.5-1-.75-2.82-2.3-6.62-2.8-9.41-2.8h0a20.91,20.91,0,0,0-3.67.32h0l.24,9.74-3.81-.11-10.85-.31s1.38-3.6-.3-4c0-.55-.09-1.17-.13-1.81-.21-2.75-.47-6.18-.73-9.65-.07-1-.15-1.94-.22-2.91a18,18,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc7829",
    d: "M606.76,819c-10.81-7.9-35.5-16.73-42.4-31.5-3.72,4.54-31.72,2.22-31.72,2.22s-6.14,14.08-5.48,22.78,1.38,18.38,1.38,18.38l14.66.42-.24-9.75s8.12-1.61,13.13,2.49,18.62,8.8,32.63,6.78S617.57,826.92,606.76,819Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c2f13",
    d: "M550.86,790.27c4.17,5.51,4.92,9.41,6.82,13.48,8.29,17.73,29.74,19.77,31.71,27l-.67.1c-14,2-27.63-2.68-32.63-6.78S543,821.56,543,821.56l.24,9.75-14.66-.42s-.72-9.67-1.38-18.38,5.48-22.78,5.48-22.78S542.18,790.52,550.86,790.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M525.91,567.72a90.78,90.78,0,0,1-5.86-43,89.63,89.63,0,0,1,7.32-26.84s69.82,10.35,89.34.59c0,0,15.62,138.53,16.11,150.74s-6.59,139.12-6.59,139.12-19,7.65-32.63,2.44c0,0-10.74-97.31-9.11-122L583.6,652C583.06,664.15,565.36,790,565.36,790s-19.53,6-32.72-.3c0,0-2.53-97.86,1.16-122.37l.37-47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa39",
    d: "M582.05,606.78c2.61-30,8-58.77,9.76-58.58,1.35.14,0,15.06-.49,49.3-.36,27.93.2,46.68,1,73.22,1.53,51.81,3.6,60.69,5.83,67.86a139.12,139.12,0,0,0,28.1,49.79c-6.4,2.88-16.78,6.2-28.37,3.64a38.76,38.76,0,0,1-4.26-1.2s-10.74-97.31-9.11-122L581,623.41C581.16,618.86,581.43,613.85,582.05,606.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa39",
    d: "M520.05,524.76a89.63,89.63,0,0,1,7.32-26.84s69.82,10.35,89.34.59h0c.76,5.69-53.65,6.82-72.12,40.9-4.58,8.46-3.47,104-4.58,130.51-2.17,51.78-.73,60.79,1,68.09a139.16,139.16,0,0,0,24.43,51.61v.08c-1.35.49-2.86,1-4.51,1.44-5.25,1.11-14.28,2.4-22.45.56-.51-.13-1-.26-1.54-.41A40.28,40.28,0,0,1,533,789.9l-.27-.12c0-.11-.12-3.18-.3-8.29-.51-24.08-1.69-94,1.35-114.13l.37-47-1.06-6.7v0l0-.09-7.18-45.8h0A90.78,90.78,0,0,1,520.05,524.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M561.39,501.63a46.31,46.31,0,0,0-1.84,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "12.19 12.19",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M557.23,519.3c-1.36,10.26-1.9,24.89.91,43.63,5.65,37.68,1.46,150.24-9,217.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M548.13,786.71q-.51,3-1,5.91"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Head/Male/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M341.24,500.67a36.88,36.88,0,0,1,5.88.87c11.3,2.56,12.92,4.43,22.39-.42,0,0,8.82-2.92,6.31,5.65,0,0,.88,1,4.51,1.93,3.46.9,21.38,1.24,10,24.2a3,3,0,0,0,2.26,4.27l30.47,1.72-8.25,30.93-53.14-14.67s.72-8.53,1-9.59c0,0-15.05,5.2-14.37-3.18s8.27-7.74,8.27-7.74l.47-3.11-22.54-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M362.88,556.32l9.95,1.74s-5.11-7.91-7-11.6a2.3,2.3,0,0,0-2.67-1.16c-4.57,1.3-15.37,3.69-14.83-2.92s8.23-6.93,11.58-6.79a1.7,1.7,0,0,0,1.76-1.44v0a1.68,1.68,0,0,0-1.26-1.9L347.32,529A13.14,13.14,0,0,1,338,512.85l2.26-8.38a4.53,4.53,0,0,1,5.19-3.28h0c-4.56-3.28-10.05-1.37-11.9-.7-11.67,4.24-15,18-15.7,21-2,8.25-1.74,20.6,3.95,23.77,1.41.78,5.11,2.75,5.11,2.75s0,5,1.71,7.22c3.17,4.11,12.64,3.48,24.35,2.66C358.45,557.53,361.31,556.9,362.88,556.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M349.88,516.62c-.29-2.48-.28-4.78-.33-7.09l-.07-3.45c0-1.17-.09-2.32-.05-3.59a9.89,9.89,0,0,1,1.61,3.35,14.69,14.69,0,0,1,.51,3.66,16.06,16.06,0,0,1-.36,3.66A11.28,11.28,0,0,1,349.88,516.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be3e5f",
    d: "M381.38,515.73c-.95-1.5-2.14-6.67-1.38-7.12l.33.09a51.08,51.08,0,0,1,6.08,1.37C386.33,513.15,381.4,515.78,381.38,515.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M353.7 538.67a5.71 5.71 0 00-1.85 3.18 1.64 1.64 0 00.55 1.38 3.27 3.27 0 001.58.59 11.2 11.2 0 003.74-.06 8.27 8.27 0 001.83-.5 2.85 2.85 0 001.53-1.1 2.77 2.77 0 01-1.3 1.54 7.16 7.16 0 01-1.88.82 9.39 9.39 0 01-4.09.29 4.05 4.05 0 01-2-.87 2.36 2.36 0 01-.7-2.19A4.81 4.81 0 01353.7 538.67zM420.11 545c-2.11 4.68-25.94 7.21-34.57 6.7s-8.31-4.17-8.31-4.17c5.49-2.6 12.87-13.69 12.87-13.69h0a3 3 0 002.52 3.39l27 1.26C420.49 540.72 420.92 543.14 420.11 545z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M356.72,513.17c0-.74-.11-1.32-.16-1.91s-.09-1.16-.1-1.74a13.61,13.61,0,0,1,.06-1.79,7.71,7.71,0,0,1,.41-2,4.77,4.77,0,0,1,1.14,1.74,5.87,5.87,0,0,1,.39,2,5.13,5.13,0,0,1-.36,2A3,3,0,0,1,356.72,513.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M384.78,517.57c-.69-.26-1.26-.41-1.82-.6s-1.1-.38-1.64-.6a13.82,13.82,0,0,1-1.61-.77,7.49,7.49,0,0,1-1.65-1.15,4.55,4.55,0,0,1,2.05-.36,5.57,5.57,0,0,1,2,.43,5.16,5.16,0,0,1,1.73,1.14A3,3,0,0,1,384.78,517.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Bottom/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M837.1,394.22C846.31,405,849.65,419,848.87,425.4c-.55,4.55,2.17,8.88,3.79,11a23.53,23.53,0,0,1,2.83,4.72c1.82,4.2,3.9,11.31-.85,14.86-3.5,2.61-6.31,2.71-10.14,4.48s-11.17,2.86-11.17,2.86c-4-6.8-13.12-24.85-18.93-25.55,1.67-2.64,2-5.47,2.76-8.79.26-1.06.46-2.14.64-3.23.12-.91.23-1.81.33-2.73.12-1.17.22-2.35.29-3.56.62-12.2-1.51-25.65-1-34.16C818.33,372,827.89,383.48,837.1,394.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M558.35,581.59S669,496.79,679.21,490.08s135.91-53.56,135.91-53.56,16.33,12.3,18.92,26.7c0,0-90,52.7-112.07,64.06l-39.43,21.37S576.78,593.29,558.35,581.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M558.35,581.59l3.87-3A46.75,46.75,0,0,0,581.37,590c20.7,6.33,40.3-2.42,44.84-4.6,23.29-11.19,23.54-28.82,45.44-49.33,4.57-4.28-53.75-7.34-49.8-8.12,61.92-12.21,111.66-29.34,118.6-32.16,18.24-7.43,48.93-16.6,84.83-49.42,3.87,4.64,7.63,10.53,8.76,16.83,0,0-90,52.7-112.07,64.06l-39.43,21.37S576.78,593.29,558.35,581.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M872.37,543.73c.92,14.12-4.83,27.33-9.3,32-3.17,3.31-3.6,8.41-3.59,11.1a22.85,22.85,0,0,1-.57,5.47c-1.06,4.46-3.67,11.39-9.59,11.37-4.37,0-6.68-1.61-10.8-2.49s-10.66-4.43-10.66-4.43c.88-7.85,4.42-27.74.2-31.79,2.92-1.1,4.88-3.17,7.49-5.38.83-.69,1.65-1.43,2.44-2.2s1.27-1.31,1.9-2c.8-.86,1.59-1.75,2.37-2.68,7.82-9.38,14.18-21.42,19.73-27.9C870.71,514.66,871.44,529.61,872.37,543.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M536.94,526.32s139.41-1.43,151.6-.67S829.4,564.38,829.4,564.38s5.68,19.63-.9,32.7c0,0-103.65-11.87-128.08-16l-44.36-6.57S575,601.84,556,597.77a89.17,89.17,0,0,1-26-10S544.67,546.73,536.94,526.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M556,597.77a89.17,89.17,0,0,1-26-10s14.61-41,6.88-61.44l4.88-.05a46.71,46.71,0,0,0,8.48,20.6c12.76,17.5,33.69,22.26,38.63,23.24,25.34,5,36.12-8.93,65.94-12.19a105.19,105.19,0,0,1,14.85-.26A254.57,254.57,0,0,1,734.09,567c19,5,49.1,16.08,97.51,11.37.31,6-.22,13-3.1,18.72,0,0-103.65-11.87-128.08-16l-44.36-6.57S575,601.84,556,597.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M726.69,528.79s-10-4.6-5.32-11.44,11.24-7.46,17.69-11.11,9-9.05,12.93-6.89a55.74,55.74,0,0,1,8.62,6.39S753.6,523,726.69,528.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Torso/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M507.59,525.29c-37.56-6.14-36.73-19-60.1-11.82-11.52,3.54-40,20.59-45.16,24.58,6.06.7,9.19.19,11.32.94,3.2,1.12-5.67,10.26-20.52,25.61a17.54,17.54,0,0,1,4.77,2.33,15.09,15.09,0,0,1,3.74,4.43A34.22,34.22,0,0,0,418.37,586a148.29,148.29,0,0,0,15.41,5.36,231,231,0,0,0,40.32,7.26c12.86,1,21.09.48,35.09,4.34,8,2.2,9.21,3.45,11.79,3,8-1.39,16.39-16.86,19.56-76.16a4.22,4.22,0,0,0-5.54-4.24C522.64,527.66,520,527.31,507.59,525.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M537.92,565.68l-4.08,26.09a77.3,77.3,0,0,1-4.17,13.4c-8.92,1-44-1.32-46.38-2l-49.5-15.2a23.34,23.34,0,0,1-13.68-10.23c-4.43-7.23-7.35-18.07,4.63-28.07l5.95-3.38a37.29,37.29,0,0,1,27.83-3.7l39.08,9.19c3.19.48,4.45-1.28,6.31,1.36a5.09,5.09,0,0,0,1.87,1.87,103.39,103.39,0,0,0,32.69,5.12C538.3,562,538.11,563.88,537.92,565.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M622.82,564.62a24,24,0,0,0-5.45,1.08c-14.81,4.81-71.5,22.57-100,22.81-9.08.08-59.1-10.56-59.1-10.56l-4.59-38,62.5,13.54a27.19,27.19,0,0,0,8.44.48l87.55-8.6a8.08,8.08,0,0,0,6-3.61c3.77-5.75,11.51-17.24,13.47-17.77,2.62-.7,7.72-.32-.54,12,0,0,2,.94,7.15-.44s24.82-7.28,25.69-5.79,6.71,3.51-20.08,11.31c0,0-.51,2.79,1.82,2.17s24.44-6.71,23-3.21-4.77,3.78-22.32,8.79c0,0-.8,2.25.15,2.31s22.09-5,22.56-3.24,4.84,2.92-25.57,9.51c0,0-.16,1.13,3.13,1.19s17.6-.19,14.53,2.35-3.7,1.93-20.42,1.88l-17.93,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M487.73,585.62a4.28,4.28,0,0,1-5.34,2.89l-48.65-14.82-.14-.05c-13.21-4.76-14.71-22.86-2.51-29.81l4.2-2.4a34,34,0,0,1,25.34-3.37l36.66,9.5a1.42,1.42,0,0,1,1,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M433.55,573.78l-1.65-.54-.82-.28-.78-.4c-.51-.28-1-.54-1.55-.84s-.95-.7-1.42-1.06a8.9,8.9,0,0,1-1.31-1.22,9.51,9.51,0,0,1-1.19-1.35l-1-1.48c-.31-.53-.56-1.08-.84-1.62a17.45,17.45,0,0,1-.17-14.31,16.27,16.27,0,0,1,4.41-5.93l.7-.62c.24-.2.51-.34.77-.52l1.55-1c1-.57,2-1.08,3-1.62s2-1.09,3.08-1.6a31.54,31.54,0,0,1,10.12-2.76,43.65,43.65,0,0,1,13.74.82c4.42,1,8.92,1.71,13.35,2.66s8.79,2.19,13.14,3.49c2.17.65,4.33,1.33,6.48,2.06,1.08.35,2.15.74,3.22,1.11l.8.3a2.34,2.34,0,0,1,.89.47,1.66,1.66,0,0,1,.42,1.84l-.29-.08a1.17,1.17,0,0,0-.57-1.2,6.85,6.85,0,0,0-1.51-.31c-1.12-.19-2.24-.37-3.36-.59-2.23-.4-4.45-.86-6.67-1.35-4.42-1-8.83-2-13.17-3.32s-8.61-2.95-13-4.13a27.46,27.46,0,0,0-13.24-.14,35.26,35.26,0,0,0-6.25,2.08c-1,.45-2,.91-2.95,1.43l-1.41.81-1.46.87-2.89,1.76-1.27.89c-.2.16-.43.28-.62.46l-.55.53a14.69,14.69,0,0,0-3.59,4.9,16.12,16.12,0,0,0-.55,12.1,15.63,15.63,0,0,0,3.24,5.45,18.48,18.48,0,0,0,5.27,4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M450.52,647H911a5.56,5.56,0,0,0,5.56-5.56V596.76a5.56,5.56,0,0,0-5.56-5.57L467.74,580.71c-3.07,0-22.78,13-22.78,16v44.67A5.56,5.56,0,0,0,450.52,647Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 603.85,
    height: 17.5,
    x: 329.62,
    y: 752.88,
    fill: "#54a4cc",
    rx: 6.08,
    transform: "rotate(-180 631.545 761.635)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54a4cc",
    points: "663.74 664.49 680.84 664.49 735.44 687.87 790.03 664.49 807.13 664.49 743.99 694.66 818.52 753.88 801.43 753.88 735.44 701.45 669.45 753.88 652.35 753.88 726.89 694.66 663.74 664.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54a4cc",
    points: "497.57 664.49 514.66 664.49 569.26 687.87 623.86 664.49 640.95 664.49 577.81 694.66 652.35 753.88 635.25 753.88 569.26 701.45 503.27 753.88 486.17 753.88 560.71 694.66 497.57 664.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M274.79,593.94,446,646.72a3.87,3.87,0,0,0,4.84-2.57l16.71-59.83a3.87,3.87,0,0,0-2.56-4.85L311.18,533.32a21.44,21.44,0,0,0-26.71,14.44l-12.25,41.33A3.89,3.89,0,0,0,274.79,593.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M259.19,599.76l1.22-4a6,6,0,0,1,7.5-4L448.77,646.7a8.33,8.33,0,0,0,3.66.29H928a5.45,5.45,0,0,1,5.46,5.45V659a5.45,5.45,0,0,1-5.46,5.46H457.72c-23.1,0-194.57-57.23-194.57-57.23A6,6,0,0,1,259.19,599.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M883.45,753.88h0a0,0,0,0,1,0,0v62a0,0,0,0,1,0,0h-17.5a0,0,0,0,1,0,0V771.38A17.5,17.5,0,0,1,883.45,753.88Z",
    transform: "rotate(180 874.7 784.875)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.51,
    cy: 815.87,
    r: 10.64,
    fill: "#454851"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.51,
    cy: 815.87,
    r: 6.35,
    fill: "#9d9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M859.66,815.87l8,12.72a15,15,0,1,0-16.48-25.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M418.26,753.88h0a0,0,0,0,1,0,0v62a0,0,0,0,1,0,0h-17.5a0,0,0,0,1,0,0V771.38A17.5,17.5,0,0,1,418.26,753.88Z",
    transform: "rotate(180 409.505 784.875)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.31,
    cy: 815.87,
    r: 10.64,
    fill: "#454851"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.31,
    cy: 815.87,
    r: 6.35,
    fill: "#9d9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M394.46,815.87l8,12.72A15,15,0,1,0,386,803.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapy);
export default __webpack_public_path__ + "static/media/physiotherapy.30d38c2ff4eaa4e5cced7d356497444a.svg";
export { ForwardRef as ReactComponent };